// extracted by mini-css-extract-plugin
var _1 = "webpack-concepts-Extraction-Blocks-Table-editor-TableEditorSettings-module__dividerLine";
var _2 = "webpack-concepts-Extraction-Blocks-Table-editor-TableEditorSettings-module__iconAndTitleContainer";
var _3 = "webpack-concepts-Extraction-Blocks-Table-editor-TableEditorSettings-module__instructionText";
var _4 = "webpack-concepts-Extraction-Blocks-Table-editor-TableEditorSettings-module__instructionWrap";
var _5 = "webpack-concepts-Extraction-Blocks-Table-editor-TableEditorSettings-module__linkToBestPractices";
export { _1 as "dividerLine", _2 as "iconAndTitleContainer", _3 as "instructionText", _4 as "instructionWrap", _5 as "linkToBestPractices" }
